/* unplugin-vue-components disabled */import script from "./page.vue?vue&type=script&setup=true&lang=js"
export * from "./page.vue?vue&type=script&setup=true&lang=js"

import "./page.vue?vue&type=style&index=0&id=ac8cb844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/@best-shot+vue-loader@17.4.9_vue@3.5.18_typescript@5.8.3__webpack@5.100.2/node_modules/@best-shot/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8cb844"]])

export default __exports__